import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';

import { CriticalErrorService } from './critical-error.service';

@Component({
    selector: 'ms-critical-error',
    templateUrl: './critical-error.component.html',
})
export class CriticalErrorComponent {
    private redirectHelper = inject(RedirectHelperService);
    private criticalErrorService = inject(CriticalErrorService);

    showCriticalError = false;
    criticalError: { header: string; text: string };

    constructor() {
        const sitecore = inject(Sitecore);

        this.criticalErrorService.criticalError$.pipe(takeUntilDestroyed()).subscribe((showError) => (this.showCriticalError = showError));

        const criticalErrorHeader = sitecore.globalMessages.CriticalErrorHeader || 'Service Connection Lost';
        const criticalErrorText = sitecore.globalMessages.CriticalErrorText || 'Retry';

        this.criticalError = {
            header: criticalErrorHeader,
            text: criticalErrorText,
        };
    }

    reloadPage(): void {
        this.redirectHelper.reloadPage();
    }
}
